<template>
  <Confirm
    :show="show"
    @close="close"
  >
    <template slot="confirm-body">
      <div
        class="create-complete"
      >
        <div>
          <img :src="`${$root.cdnUrl}assets/icon-complete.svg`">
        </div>
        <div>
          <h4 class="complete-title">
            Tebrikler Ürününüz Listenize Eklenerek Onaya Gönderildi!
          </h4>
          <div class="complete-subtitle">
            Müşterilerimize en doğru bilgilerle satışa sunmak amacıyla,
            Trendyol'da listelenen tüm ürünler kontrol edilmektedir.
            Kontrol süreci ortalama 3 iş günü içerisinde tamamlanacaktır.
            <span @click="backToList">Ürün Listesi</span>
            ekranı üzerinden onay durumunu takip edebilirsiniz.
          </div>
        </div>

        <button
          class="btn btn-trendyol"
          @click="close"
          type="button"
        >
          KAPAT
        </button>
      </div>
    </template>
  </Confirm>
</template>
<script>
import mobile from '@/utils/mobile';
import Confirm from '@/components/Confirm';
export default {
  name: 'PopupProductSuccess',
  components: { Confirm },
  props: {
    show: {
      type: Boolean,
      default: () => true,
    },
    barcode: {
      type: String,
      default: () => null,
    },
  },
  methods: {
    close () {
      this.$emit('close');
    },
    backToList () {
      mobile.navigationNavigate({
        pageName: 'Product',
        params: { reload: Date.now(), barcode: this.barcode },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .create-complete {
    text-align: center;

    .complete-title {
      font-size: 18px;
      font-weight: 500;
      color: #0bc15c;
      margin-bottom: 30px;
    }
    .complete-subtitle{
      color: rgb(39, 49, 66);
      margin-bottom: 50px;
      span {
        color: rgb(242, 122, 26);
        border-bottom: 1px solid rgb(242, 122, 26);
      }
    }
  }
</style>
